import { HdBodygraphConfig, HdBodygraphPlanetaryActivation } from './hd-bodygraph.models';

/** Cycle-keys (app-vocabulaire, spec cycle charts §3) — string-union, bewust geen enum. */
export type HdCycleKey =
  | 'saturnReturn'
  | 'uranusOpposition'
  | 'chironReturn'
  | 'secondSaturnReturn'
  | 'uranusReturn'
  | 'jupiterReturn'
  | 'solarReturn'
  | 'justNow';

/** Weergavevolgorde in de Cycles-sectie. */
export const HD_CYCLE_KEYS: readonly HdCycleKey[] = [
  'saturnReturn',
  'uranusOpposition',
  'chironReturn',
  'secondSaturnReturn',
  'uranusReturn',
  'jupiterReturn',
  'solarReturn',
  'justNow',
];

/** Eén exacte kruising; de latere zijn actuaties van dezelfde cyclus (spec §1). */
export interface HdCyclePassageV1 {
  utc: string;
  retrograde: boolean;
}

/** Natal-kern voor verouderd-detectie (spec §6.1) + terugnavigatie. */
export interface HdCycleSourceRefV1 {
  chartId: string;
  name: string;
  birthDateUtc: string | null;
  latitude: number | null;
  longitude: number | null;
  timezone: string | null;
}

/** Volledige chart (P+D) van het cycle-moment, berekend op de natal-geboortelocatie. */
export interface HdCycleMomentChartV1 {
  birthData: Record<string, unknown>;
  configuration: HdBodygraphConfig;
  planetaryActivations: HdBodygraphPlanetaryActivation[];
  metadata?: Record<string, unknown>;
}

/** Het cycle-blok in een Cycle-chartdocument (spec §6); top-level = natal-snapshot. */
export interface HdCycleChartInfoV1 {
  schemaVersion: 1;
  key: HdCycleKey;
  anchorUtc: string;
  solarReturnYear?: number;
  /** Jupiter-return: volgnummer (1 = ±12 jaar, 2 = ±24 jaar, …). */
  jupiterReturnNumber?: number;
  passages: HdCyclePassageV1[];
  source: HdCycleSourceRefV1;
  moment: HdCycleMomentChartV1;
}

/** Verzoek uit de Cycles-sectie aan de page om een cycle chart te berekenen/openen. */
export interface HdCycleCalculateRequest {
  key: HdCycleKey;
  /** null = Just now: de page gebruikt het huidige moment als anchor. */
  anchorUtc: string | null;
  passages: HdCyclePassageV1[];
  solarReturnYear?: number;
  jupiterReturnNumber?: number;
}
